import FaqItem from "./FaqItem";

interface FaqListProps {
    items: FaqListItem[]
    doNotCenter?: boolean
    useGradientBackground?: boolean
}

interface FaqListItem {
    question: string
    answer: string
}

export default function FaqList(props: FaqListProps) {
    const {items, doNotCenter, useGradientBackground = true} = props;

    return <div className={`mw-md-3xl ${doNotCenter ? '' : 'mx-auto'}`}>
        <div className='row g-6'>
            {items.map((item) => (
                <FaqItem question={item.question} key={item.question}
                         answer={item.answer} useGradientBackground={useGradientBackground}/>
            ))}
        </div>
    </div>

}